// extracted by mini-css-extract-plugin
export default {"quizCreatorAnswerShower":"QuizCreatorAnswerShower_quizCreatorAnswerShower__LPZ-d","option":"QuizCreatorAnswerShower_option__Xijam","title":"QuizCreatorAnswerShower_title__FPUKM"};